import styled, { createGlobalStyle } from 'styled-components';

export const defaultStyle = {
    colors: {
        dark: '#172130',
        blue: '#3D6099',
        red: '#F26753',
        lightRed: '#FF8A5E',
        light: '#E8F1FF',
        white: '#FFFFFF',
    },
};

export const Container = styled.div`
    background-color: ${defaultStyle.colors.dark};
    width: 100vw;
    height: 100vh;
`;

interface Props { }
export const GlobalStyle = createGlobalStyle<Props>`
    * {
        margin: 0;
        padding: 0;
        font-family: 'Montserrat';
    }

    button, a {
        cursor: pointer;
        outline: 0;
    }

    html {
        height: 100%;
    }

    a {
        text-decoration: none;

        &:link {
            color: inherit;
        }

        &:visited {
            color: inherit;
        }

        &:hover {
            color: inherit;
        }

        &:active {
            color: inherit;
        }
    }

    html,
    body,
    body > div:first-child,
    div#root {
        height:100%;
        margin:0;
        padding:0;
        box-sizing: border-box;
    }

    html, body {
        background-size: cover;
        background-color: ${defaultStyle.colors.dark};
        position: fixed;
    }
`;
